<ifp-docusign-sign-step *ngIf="isDocuSignSigning"
                        [subject]="signingSubject"
                        [summary]="docuSignSummary"></ifp-docusign-sign-step>

<ng-container *ngIf="!isDocuSignSigning">
  <div id="agreement-wrapper">
    <div>
      <div>
        Review {{locAgreement?.showHeader ? 'and accept ' : ''}} your {{locAgreement?.name}}
      </div>

      <div>
        <button *ngIf="!isInWebView"
                mat-icon-button
                (click)="print()">
          <mat-icon>print</mat-icon>
        </button>
        <button mat-icon-button
                (click)="download()">
          <mat-icon>file_download</mat-icon>
        </button>
      </div>
    </div>

    <section>
      <section class="content-terms"
               *ngIf="locAgreement?.showHeader">
        <div>{{data.loan.entityName}} - {{data.loan.loanNumber}}</div>
        <div fxLayout.xs="column"
             fxLayoutGap.xs="12px">
          <div>
            <div>{{currentOffer.amount | currency}}</div>
            <div>{{agreementInfo?.productCode === productCodes.Term ? 'Loan amount' : 'Credit limit'}}</div>
          </div>
          <div>
            <div>{{currentOffer.repaymentTerm}} months</div>
            <div>Term</div>
          </div>
          <div>
            <div>{{loanOfferPaymentFrequencyLabel}}</div>
            <div>Payment frequency</div>
          </div>
        </div>
      </section>

      <section class="flex column center-center layout margin-top">
        <button mat-flat-button
                color="primary"
                (click)="start()"
                class="layout margin-bottom"
                *ngIf="hasPendingDisclosures">Review {{categoryName}}</button>
      </section>

      <section *ngIf="locAgreement?.showHeader && agreementInfo?.productCode === productCodes.Term"
               class="content-term-loan-addon">
        <div>
          <span *ngIf="currentOffer.originationFeeType === FeeType.Percentage">Origination fee ({{currentOffer.originationFee / 100 | percent:'1.2-2'}})</span>
          <span *ngIf="currentOffer.originationFeeType !== FeeType.Percentage">Origination fee
            ({{currentOffer.originationFee | currency:'USD':'symbol':'1.2-2'}})</span>
          <span>{{termLoanOfferDetails.originationFeeAmount | currency:'USD':'symbol':'1.2-2'}}</span>
        </div>
        <div>
          <span>Factor rate</span>
          <span>{{termLoanOfferDetails.factorRate | number:'1.4-4'}}</span>
        </div>
        <div>
          <span>Total repayment amount</span>
          <span>{{termLoanOfferDetails.totalRepaymentAmount | currency:'USD':'symbol':'1.2-2'}}</span>
        </div>
        <div>
          <span>{{loanOfferPaymentFrequencyLabel}} payment</span>
          <span>{{termLoanOfferDetails.paymentAmount | currency:'USD':'symbol':'1.2-2'}}</span>
        </div>
      </section>

      <ifp-agreement-document #agreementDocument
                              [html]="locAgreement?.html"
                              [disclosures]="locAgreement?.disclosures"
                              [signerInitials]="locAgreement?.signerInitials"
                              [acceptGuard]="disclosureAcceptGuard"
                              (progressChange)="onDisclosureProgress($event)"
                              (completed)="onDisclosuresCompleted()"></ifp-agreement-document>

      <section class="flex column center-center layout margin-top">
        <button #acceptButton
                mat-flat-button
                color="primary"
                (click)="review()"
                class="layout margin-bottom"
                [class.agreement-accept--bump]="acceptButtonBumped">{{locAgreement?.showHeader ? 'Accept ' + categoryName : 'I Confirm'}}</button>
      </section>

    </section>

  </div>
</ng-container>
